import { render, staticRenderFns } from "./PaymentStep.vue?vue&type=template&id=7d64bbde&scoped=true&lang=pug"
import script from "./PaymentStep.vue?vue&type=script&lang=js"
export * from "./PaymentStep.vue?vue&type=script&lang=js"
import style0 from "./PaymentStep.vue?vue&type=style&index=0&id=7d64bbde&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d64bbde",
  null
  
)

export default component.exports